export class Form {

  protected formStatus = {};
  protected isFormValid: boolean;

  setFormStatus(result, index) {
    this.formStatus[index] = result;
  }

  getFormStatus(): boolean {
    let result: boolean;
    for (status in this.formStatus) {
      if (this.formStatus[status] === false) {
        result = false;
        break;
      } else {
        result = true;
      }
    }
    return result;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/form.ts